import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Instagram, Facebook, Twitter } from "lucide-react";
import { COMPANY, SERVICES } from "../../lib/constants";

export const Footer = () => {
  const waLink = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}`;

  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2">
              <img
                src={COMPANY.logoUrl}
                alt="M Brother's Cleaning Services"
                className="h-24 md:h-32 w-auto object-contain"
              />
            </Link>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Premium, eco-friendly cleaning for homes and businesses across {COMPANY.area}.
              Reliable. Professional. Spotless.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="#"
                aria-label="Instagram"
                data-testid="social-instagram"
                className="w-9 h-9 rounded-md border border-slate-800 flex items-center justify-center hover:border-blue-500 hover:text-white transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                data-testid="social-facebook"
                className="w-9 h-9 rounded-md border border-slate-800 flex items-center justify-center hover:border-blue-500 hover:text-white transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                data-testid="social-twitter"
                className="w-9 h-9 rounded-md border border-slate-800 flex items-center justify-center hover:border-blue-500 hover:text-white transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-white text-sm font-semibold tracking-wide uppercase">
              Services
            </h4>
            <ul className="mt-5 space-y-2.5 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    data-testid={`footer-service-${s.slug}`}
                    className="hover:text-white transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold tracking-wide uppercase">
              Company
            </h4>
            <ul className="mt-5 space-y-2.5 text-sm">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-white text-sm font-semibold tracking-wide uppercase">
              Contact
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-blue-400" />
                <span>{COMPANY.area}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-blue-400" />
                <a
                  href={`tel:${COMPANY.phoneClean}`}
                  data-testid="footer-phone"
                  className="hover:text-white"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 text-[#25D366]" />
                <a
                  href={waLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-white"
                >
                  WhatsApp Chat
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-400" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-800/80 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p
            data-testid="agency-credit"
            className="text-xs text-slate-500"
          >
            Website Managed by{" "}
            <a
              href="https://verifieddigital.solutions/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="agency-link"
              className="text-slate-200 font-medium hover:text-blue-400 transition-colors underline-offset-4 hover:underline"
            >
              {COMPANY.agency}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
